<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div class="add-input">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;" v-if="isAdmin || isCooperate">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增用户
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="昵称" align="center"
                             prop="nickname"></el-table-column>
            <el-table-column show-overflow-tooltip label="头像" align="center"
                             prop="imageUrl">
              <template slot-scope="scope">
                <img :src="scope.row.imageUrl" style="width: 50px;height: 50px;" v-if="scope.row.imageUrl">
                <span v-else>暂无</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="合作方" align="center"
                             prop="cooperateName" v-if="!isCooperate"></el-table-column>
            <el-table-column show-overflow-tooltip label="手机号" align="center"
                             prop="phone"></el-table-column>
            <el-table-column show-overflow-tooltip label="邮箱" width="200" align="center"
                             prop="email"></el-table-column>
            <el-table-column show-overflow-tooltip label="角色" width="300" align="center" prop="roleNames"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" width="300" align="center"
                             prop="remark"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="160" align="center">
              <template slot-scope="scope">
                <!-- 超级管理员账号不可操作 -->
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteUser(scope.row.id)" v-if="scope.row.id != 1">删除</el-button>
                <el-button type="text" disabled v-else>删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="userDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增用户' : '编辑用户'">
      <el-form ref="userForm" label-position="right" label-width="120px" :model="userDialog.formData"
               :rules="rules" style="height: 550px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="昵称：" prop="nickname">
          <el-input placeholder="请输入昵称" v-model="userDialog.formData.nickname"
                    clearable/>
        </el-form-item>
        <el-form-item label="头像：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :multiple="false"
            :file-list="fileList"
            :on-success="handleSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input placeholder="请输入密码" v-model="userDialog.formData.password"
                    clearable type="password"/>
        </el-form-item>
        <el-form-item label="手机：" prop="phone">
          <el-input placeholder="请输入手机号" v-model="userDialog.formData.phone"
                    clearable/>
        </el-form-item>
        <el-form-item label="身份证：">
          <el-input placeholder="请输入身份证" v-model="userDialog.formData.idCard"
                    clearable/>
        </el-form-item>
        <el-form-item label="角色：" prop="roleIds">
          <el-select filterable v-model="userDialog.formData.roleIds" placeholder="请选择角色" clearable :disabled="userDialog.formData.roleIds == '1'" style="width: 100%;">
            <el-option v-for="item in roles" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中介地址显示：" prop="thirdSwitch" v-if="userDialog.formData.roleIds == 6 && isAdmin">
          <el-switch :active-value="true" :inactive-value="false" v-model="userDialog.formData.thirdSwitch"></el-switch>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="userDialog.formData.remark" clearable/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="userDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateUser" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="cooperateDialog.visible" :close-on-click-modal="false" width="40%" title="合作方">
      <cooperate></cooperate>
    </el-dialog>
  </div>
</template>
<script>


import {getPageList, deleteData, saveOrUpdateData} from "@/api/user";
import {getAllRoles} from "@/api/role";
import {getList} from "@/api/cooperate";
import Cooperate from '@/components/Cooperate';

export default {
  components: {
    Cooperate
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        const reg = new RegExp("^1[3-9]\\d{9}$");
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }
    }
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: ''
        },
        total: 0,
        data: []
      },
      userDialog: {
        formData: {
          nickname: '',
          imageUrl: '',
          account: '',
          password: '',
          oldPassword: '',
          phone: '',
          email: '',
          idCard: '',
          roleIds: '',
          remark: '',
          isRegister: false,
          isCooperate: false,
          cooperateId: '',
          cooperateName: '',
          thirdSwitch: false
        },
        visible: false
      },
      rules: {
        nickname: [
          {trigger: 'blur', required: true, message: '请输入昵称'}
        ],
        imageUrl: [
          {trigger: 'change', required: true, message: '请上传头像'}
        ],
        isCooperate: [
          {trigger: 'blur', required: true, message: '请选择是否合作方'}
        ],
        cooperateId: [
          {trigger: 'blur', required: true, message: '请选择合作方'}
        ],
        account: [
          {trigger: 'blur', required: true, message: '请输入账号'}
        ],
        password: [
          {trigger: 'blur', required: true, message: '请输入密码'}
        ],
        phone: [
          {trigger: 'blur', required: true, validator: validatePhone}
        ],
        roleIds: [
          {trigger: 'change', required: true, message: '请选择角色'}
        ],
        thirdSwitch: [
          {trigger: 'change', required: true, message: '请设置中介地址显示'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      roles: [],
      allRoles: [],
      fileList: [],
      cooperateDialog: {
        visible: false
      },
      isAdmin: false,
      isCooperate: false,
      cooperates: [],
      userInfo: {}
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.isAdmin = this.userInfo.roleIds.indexOf('1') != -1
    this.isCooperate = this.userInfo.roleIds.indexOf('4') != -1
    this.getRoles()
  },
  methods: {
    // 格式化角色显示
    formatRole(roleIds) {
      if (roleIds) {
        const ids = roleIds.split(',')
        const roles = this.allRoles.filter(role => ids.indexOf(role.id + '') != -1)
        if (roles && roles.length > 0) {
          return roles.map(role => role.name).join(',')
        }
      }
      return '未分配角色'
    },
    // 获取所有角色
    getRoles() {
      getAllRoles().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.roles = response.data
          this.allRoles = response.data
          if (this.isCooperate) {
            this.roles = this.allRoles.filter(item => item.id == 5)
          } else {
            this.roles = this.allRoles.filter(item => item.id != 5)
          }
          this.search(true)
        } else {
          // 查询失败
          this.$message.error('查询角色失败!')
        }
      })
    },
    // 获取所有合作方
    getCooperates() {
      getList().then(response => {
          this.cooperates = response.data
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        withoutDelete: true
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
          // 格式化角色显示
          if (this.table.data && this.table.data.length > 0) {
            for (let item of this.table.data) {
              item.roleNames = this.formatRole(item.roleIds)
            }
          }
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改用户
    saveOrUpdateUser() {
      this.loading = true
      this.$refs['userForm'].validate(async (valid) => {
        if (valid) {
          if (this.isCooperate) {
            this.userDialog.formData.cooperateId = this.userInfo.id
            this.userDialog.formData.cooperateName = this.userInfo.nickname
          }
          this.userDialog.formData.account = this.userDialog.formData.phone
          this.userDialog.formData.fromPc = true
          saveOrUpdateData(this.userDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.userDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.fileList = []
      this.getCooperates()
      this.getRoles()
      if (isEdit) {
        this.userDialog.formData = JSON.parse(JSON.stringify(data))
        // 角色回显
        this.userDialog.formData.roleIds = parseInt(this.userDialog.formData.roleIds)
      } else {
        // 重置数据
        this.userDialog.formData = {
          nickname: '',
          imageUrl: '',
          account: '',
          password: '',
          oldPassword: '',
          phone: '',
          email: '',
          roleIds: '',
          remark: '',
          idCard: '',
          isRegister: false,
          isCooperate: this.isCooperate,
          cooperateId: this.isCooperate ? this.userInfo.cooperateId : '',
          cooperateName: this.isCooperate ? this.userInfo.cooperateName : ''
        }
      }
      this.userDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.userForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除人员
    deleteUser(id) {
      this.$confirm('此操作将永久删除用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error('操作失败!')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSuccess(response, file) {
      this.userDialog.formData.imageUrl = response.url
    },
    openCooperateDialog() {
      this.cooperateDialog.visible = true
    },
    changeRole() {
      if (this.userDialog.formData.isCooperate) {
        this.roles = this.allRoles.filter(item => item.id == 4 || item.id == 5)
      } else {
        this.roles = this.allRoles.filter(item => item.id != 4 && item.id != 5)
      }
      this.userDialog.formData.roleIds = ''
      this.userDialog.formData.roleNames = ''
      this.$nextTick(() => {
        this.$refs.userForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue